// imports
import { MouseEvent } from 'react';
import Link from 'next/link';
import { useAtom } from 'jotai';

// lib files
import { VideoClass } from '@/lib/types/api/video';
import {
  MyListConfirmModalTypeEnum,
  myListConfirmModalAtom
} from '@/lib/atoms/my-list-confirm-modal';

// components
import KabobMenu from '@/components/KabobMenu/KabobMenu';
import VideoThumbnail from '@/components/VideoThumbnail/VideoThumbnail';

// svgs
import PlayIcon from '@/public/svg/play.svg';
import ShowsIcon from '@/public/svg/shows.svg';
import MinusIcon from '@/public/svg/minus.svg';

// styles
import styles from './MyListViewingHistoryGridItem.module.scss';

interface MyListViewingHistoryGridItemProps {
  video: VideoClass;
}

const MyListViewingHistoryGridItem = (props: MyListViewingHistoryGridItemProps) => {
  const { video } = props;

  const { show, cid, slug, title } = video;

  const [ _, setConfirmModalState ] = useAtom(myListConfirmModalAtom);

  const handleRemoveClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const modalState = {
      id: cid,
      isOpen: true,
      slug: slug,
      title: title,
      type: MyListConfirmModalTypeEnum.VIEWING_HISTORY,
    }
    setConfirmModalState(modalState);
  }

  return (
    <div className={styles.my_list_viewing_history_grid_item}>
      <VideoThumbnail video={video} />
      <KabobMenu
        className={styles.my_list_viewing_history_kabob_menu}
        contentClassName={styles.my_list_viewing_history_kabob_menu_content}
      >
        <ul>
          <li>
            <Link href={`/video/${slug}/`} className={styles.my_list_viewing_history_link}>
              <PlayIcon />
              Continue Watching
            </Link>
          </li>
          <li>
          { show && (
            <Link href={`/show/${show.slug}/`} className={styles.my_list_viewing_history_show_link}>
              <ShowsIcon />
              Explore the Show
            </Link>
          )}
          </li>
          <li>
            <button
              className={styles.my_list_viewing_history_remove_button}
              onClick={handleRemoveClick}>
              <MinusIcon />
              Remove from Viewing History
            </button>
          </li>
        </ul>
      </KabobMenu>
    </div>
  );
};

export default MyListViewingHistoryGridItem;
